import i18next from "i18next";
import {
    validateCurrencyAmount,
    validateEmail,
    validatePhone,
    validateRequired,
    validateSSN,
    validateZip,
} from "./validation";

const TRANSLATION_KEY = "Form.Validators";

export type ErrorMessage = (value: any) => string | string;

export type ValidatorFunction = (value: any, errorMessage?: ErrorMessage) => string;

export function required(value: any, errorMessage?: ErrorMessage): string {
    return validate(value, validateRequired, i18next.t(TRANSLATION_KEY + ".requiredMessage"), errorMessage);
}

export function email(value: any, errorMessage?: ErrorMessage): string {
    return validate(value, validateEmail, i18next.t(TRANSLATION_KEY + ".invalidEmailMessage"), errorMessage);
}

export function phone(value: any, errorMessage?: ErrorMessage): string {
    return validate(value, validatePhone, i18next.t(TRANSLATION_KEY + ".invalidPhoneMessage"), errorMessage);
}

export function USZipCode(value: any, errorMessage?: ErrorMessage): string {
    return validate(
        value,
        () => validateZip(value, true),
        i18next.t(TRANSLATION_KEY + ".invalidZipCodeMessage"),
        errorMessage
    );
}

export function CanadianPostalCode(value: any, errorMessage?: ErrorMessage): string {
    return validate(
        value,
        () => validateZip(value, false),
        i18next.t(TRANSLATION_KEY + ".invalidPostalCodeMessage"),
        errorMessage
    );
}

export function SSN(value: any, errorMessage?: ErrorMessage): string {
    return validate(
        value,
        () => validateSSN(value, true),
        i18next.t(TRANSLATION_KEY + ".invalidSocialSecurityNumberMessage"),
        errorMessage
    );
}

export function CanadianSSN(value: any, errorMessage?: ErrorMessage): string {
    return validate(
        value,
        () => validateSSN(value, false),
        i18next.t(TRANSLATION_KEY + ".invalidSocialInsuranceNumberMessage"),
        errorMessage
    );
}

export function currencyAmount(value: any, errorMessage?: ErrorMessage): string {
    return validate(
        value,
        validateCurrencyAmount,
        i18next.t(TRANSLATION_KEY + ".invalidCurrencyAmountMessage"),
        errorMessage
    );
}

function validate(
    value: any,
    validator: (value: any) => boolean,
    defaultErrorMessage: string,
    errorMessage?: ErrorMessage
): string {
    return !validator(value) ? (errorMessage ? getErrorMessage(value, errorMessage) : defaultErrorMessage) : "";
}

function getErrorMessage(value: any, errorMessage: ErrorMessage) {
    return typeof errorMessage === "string" // tslint:disable-line
        ? errorMessage
        : errorMessage(value);
}
